import React, { useState } from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import {
  newAppointmentTags,
  showAppointmentTags,
} from '~/config/routes';
import Request from '~/providers/Request';
import AppointmentTagsRecord from '~/records/AppointmentTagsRecord';
import Form from './Form';

function NewRecord({ history }) {
  const [record, setRecord] = useState(new AppointmentTagsRecord());
  const [loading, setLoading] = useState(false);

  async function onSubmit(saveAndContinue) {
    const data = record.toParams();

    Request.post(
      '/admin/appointment_tags',
      data,
      {},
      { controller: 'appointmentTags' }
    )
      .then((resp) => {
        setLoading(false);
        if (saveAndContinue) {
          history.push(newAppointmentTags.spec);
        } else {
          history.push(showAppointmentTags.reverse(resp.data));
        }
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord(record.updateAttributes(attrs));
  };

  return (
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

NewRecord.propTypes = {
  history: historyPropType,
};

export default NewRecord;
